import React from "react";
import { ResizableBox as ReactResizableBox } from "react-resizable";

import "react-resizable/css/styles.css";

export default function ResizableBox({ children, height = 450, style = {}, className = "" }) {
	return (
		<div
			style={{
				display: "inline-block",
				width: "auto",
				background: "white",
				padding: ".5rem",
				borderRadius: "0.5rem",
				boxShadow: "0 30px 40px rgba(0,0,0,.1)",
				...style,
			}}
		>
			<ReactResizableBox width={"100%"} height={height}>
				{children}
			</ReactResizableBox>
		</div>
	);
}
